<script>

export default {
    props: {
        'title': String,
        'value': Object,
        'success': Function,
    },
    data() {
        return {
            data: {},
            routeName: 'branch',
        }
    },
    mounted() {
        var vm = this;

        vm.newData();
        vm.load();
    },
    methods: {
        load() {
            var vm = this;

            if (vm.$route.query.keyword)
                vm.data.keyword = vm.$route.query.keyword;

            if (vm.$route.query.store_id)
                vm.data.store_id = vm.$route.query.store_id;

            if (vm.$route.query.is_open)
                vm.data.is_open = vm.$route.query.is_open;
        },
        newData() {
            var vm = this;

            var data = {
                keyword: null,
                store_id: null,
                is_open: null,
            };

            vm.data = Object.assign({}, data);
        },
        async submit() {
            var vm = this;

            vm.success(vm.data);
            vm.$sidebar.hide();
        },
        fetchStore: async function (params) {
            const resp = await this.$api.Store.all(params)

            const data = resp.data.data

            const list = data.map(row => ({
                id: row.id,
                text: row.text,
                model: row,
            }))

            const meta = resp.data.meta

            return {
                options: list,
                more: meta.current_page < meta.last_page
            }
        },
        fetchStatus: async function () {
            var vm = this;

            const list = [
                { id: 0, text: vm.$t('branch.status.closed') },
                { id: 1, text: vm.$t('branch.status.open') }
            ];

            return {
                options: list,
                more: false
            }
        },
    }
}
</script>

<template>
    <b-form @submit="submit">
        <simplebar class="h-100 sidebar-simplebar">
            <div class="p-4">
                <BRow class="gy-3">
                    <BCol lg="12">
                        <label class="form-label" for="product-title-input">{{ $t('filter.label.keyword') }}</label>
                        <input type="text" class="form-control" v-model="data.keyword" id="product-title-input"
                            :placeholder="$t('filter.placeholder.keyword')" />
                    </BCol>
                    <BCol lg="12">
                        <label for="choices-publish-status-input" class="form-label">{{
                            $t('branch.label.store')
                        }}</label>
                        <dynamic-select v-model="data.store_id" :placeholder="$t('branch.placeholder.store')"
                            :loadOptions="fetchStore" />
                    </BCol>
                    <BCol lg="12">
                        <label for="choices-publish-status-input" class="form-label">{{
                            $t('branch.label.status')
                        }}</label>
                        <dynamic-select v-model="data.is_open" :placeholder="$t('branch.placeholder.status')"
                            :loadOptions="fetchStatus" />
                    </BCol>
                    <BCol lg="12" class="mt-5" v-if="$ac.hasAccess('branch_full_access') || ($ac.hasAccess('branch_list'))">
                        <BRow>
                            <BCol cols="6">
                                <BButton type="button" variant="light" class="w-100" id="reset-layout"
                                    @click="$sidebar.hide()">
                                    <i class="mdi mdi-arrow-left align-bottom me-1"></i>
                                    {{ $t('basic.btn.cancel') }}
                                </BButton>
                            </BCol>
                            <BCol cols="6">
                                <BButton type="submit" variant="primary" class="w-100" @click="submit"
                                    :disabled="$loading.get([routeName, 'list'].join('_'))">
                                    <loading :loading="$loading.get([routeName, 'list'].join('_'))">
                                        <i class="mdi mdi-filter-outline me-1"></i>
                                        {{ $t('basic.btn.filter') }}
                                    </loading>
                                </BButton>
                            </BCol>
                        </BRow>
                    </BCol>
                </BRow>
            </div>
        </simplebar>
    </b-form>
</template>